export default __webpack_public_path__ + "static/media/gammes.03565be0.xlsx";